// src/hooks/useCategories.js
import { useState, useEffect } from 'react';
import { fetchCategories } from '../services/api';

export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadCategories = async () => {
    try {
      setLoading(true);
      setError(null);

      const data = await fetchCategories();
      setCategories(data); // On suppose que fetchCategories retourne un tableau directement
    } catch (err) {
      setError(err.message || 'Erreur lors du chargement des catégories.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCategories();
  }, []);

  return {
    categories,
    loading,
    error,
    refetch: loadCategories
  };
};
